import React, { useEffect, useState } from 'react';
import DefaultSelect from 'components/DefaultSelect';
import MultiSelectV2 from '../MultiSelectV2';
import BaseService from 'services/BaseService';

const OptionSelectV2 = ({ onSelect, value, isRequired, error, helperText, disabled, codigo, multiSelect, label }) => {
  const [optionsByCode, setOptionsByCode] = useState([]);
  
  const getOptions = async () => {
    try {
      const response = await BaseService.get({ url: `options/${codigo}` });
      if (multiSelect) {
        setOptionsByCode(response.data.map(o => ({value: o.id, label: o.value})));
      } else {
        setOptionsByCode(response.data.map(o => ({id: o.id, nome: o.value})));
      }
    } catch (e) {
      console.error(e);
    }
  }

  useEffect(() => { getOptions(codigo); }, [codigo]);

  if (multiSelect) {
    return (
      <MultiSelectV2
        label={label}
        onChange={values => { onSelect(values ? values.map(v => v.value) : null) }}
        defaultValue={
          optionsByCode && value && value.length
            ? optionsByCode.filter(o => value.indexOf(o.value) > -1)
            : []
        }
        options={optionsByCode}
      />
    )
  }

  return (
    <DefaultSelect 
      error={error} helperText={helperText} isRequired={isRequired}
      label={label}
      onSelect={event => onSelect(event.target.value, event.target.options[event.target.selectedIndex].text)}
      options={optionsByCode} value={value} disabled={disabled}
    />
  );
}

export default OptionSelectV2;
